document.addEventSelectorListener("click", "[data-active-group]", function(event, target) {
	for (let element of document.querySelectorAll("[data-active-group='" + target.getAttribute("data-active-group") + "']")) {
		element.classList.toggle("active", target == element);
	}
});